import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import long from "../../../assets/icons/long.png";
import medium from "../../../assets/icons/medium.png";
import short from "../../../assets/icons/short.png";

const cardStyle = {
  bgcolor: "#fff",
  color: "#000",
};

const objectList = [
  {
    icon: short,
    title: "Immediate outcomes (1-3 years)",
    subtitle:
      "Promotion of an innovative environment through identification and engagement of the AIR Fellows.",
    subtitle2:
      "number of pilots launched, innovators supported, and levels of community participation and engagement achieved.",
  },
  {
    icon: medium,
    title: "Medium term outcomes (3-5 years)",
    subtitle:
      "monitor the progress of AIR funded projects, review lessons learned, and shape future outcomes, and examine grantees’ paths to financial sustainability.",
    subtitle2:
      "adoption of innovative solutions, increased access to sustainable services, and strengthened collaboration among innovators and communities. ",
  },
  {
    icon: long,
    title: "Long-term outcomes (5 years and beyond)",
    subtitle:
      "Establishment of resilient, self-sustaining ecosystems across Africa by supporting the growth of independent innovation hubs, fostering solutions for climate adaptation, and driving AI and social innovation in localized contexts. Once underrepresented groups begin leading transformative efforts while maintaining progress without external dependence.  ",
    subtitle2: "",
  },
];

const Outcome = () => {
  return (
    <Box margin={{ xs: "35% 0% 30% 0%", sm: "10% 0% 10% 0%" }}>
      <Typography
        variant="h3"
        fontWeight={700}
        textAlign={"left"}
        paddingBottom={{ xs: "4%", sm: "2%" }}
        color={"#39484E"}
      >
        Outcome Pathways
      </Typography>
      <Grid container spacing={1}>
        {objectList.map((list, index) => {
          const { title, icon, subtitle, subtitle2 } = list;
          return (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                margin={{ xs: "5% 0%", sm: "0%" }}
              >
                <Box
                  key={index}
                  component={Card}
                  height={"100%"}
                  padding={{ xs: "4% 4%", sm: "8% 8% 4% 8%" }}
                  margin={{ xs: "2% 0%", sm: "4% 0%" }}
                  borderRadius={"20px"}
                  display={"flex"}
                  flexDirection={"column"}
                  width={{ xs: "100%", sm: "100%" }}
                  sx={{ ...cardStyle }}
                >
                  <Box marginLeft={"2%"}>
                    {" "}
                    <Box
                      component="img"
                      height={{ xs: "64px", sm: "64px" }}
                      sx={{
                        objectFit: "cover",
                        overflow: "hidden",
                        width: "100%",
                      }}
                      src={icon}
                      alt={"icons"}
                    />
                  </Box>
                  <Typography
                    variant={"h5"}
                    fontWeight={700}
                    paddingTop={"6%"}
                    color={"#39484E"}
                  >
                    {title}
                  </Typography>
                  <Typography
                    variant={"body1"}
                    paddingTop={"6%"}
                    color={"#000"}
                  >
                    {subtitle}
                  </Typography>
                  <Typography
                    variant={"body1"}
                    paddingTop={"2%"}
                    color={"#000"}
                  >
                    <strong>Progress metrics: </strong>
                    {subtitle2}
                  </Typography>
                </Box>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Outcome;
